// src/components/layout/DashboardLayout.tsx

import * as React from 'react';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { CssBaseline, CssVarsProvider } from '@mui/joy';
import Box from '@mui/joy/Box';
import SideNav from './SideNav';
import Header from './Header';
import FranchiseAlertModal from '../modals/FranchiseAlertModal';
import { openSidebar, closeSidebar, isMobile } from '../../utils';

export default function DashboardLayout() {
    const location = useLocation();
    const isMessagesPage = location.pathname.startsWith('/dashboard/messages') || location.pathname === '/messages';
    const isFullBleedPage = isMessagesPage || location.pathname.startsWith('/dashboard/support-tickets');

    useEffect(() => {
        // On mobile, always start with sidebar closed
        if (isMobile()) {
            closeSidebar();
        } else {
            const savedState = localStorage.getItem('sidebar-open');
            if (savedState === 'false') {
                closeSidebar();
            } else {
                openSidebar();
            }
        }

        // Handle resize events to close sidebar when switching to mobile
        const handleResize = () => {
            if (isMobile()) {
                closeSidebar();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <CssVarsProvider disableTransitionOnChange>
            <CssBaseline />
            <FranchiseAlertModal />
            <Box sx={{ display: 'flex', height: '100dvh' }}>
                <SideNav />
                    <Header />
                    <Box
                        component="main"
                        className="MainContent"
                        sx={{
                            overflowY: isFullBleedPage ? 'hidden' : 'scroll',
                            // On mobile (xs), sidebar overlays content so no margin needed
                            // On tablet/desktop (sm+), sidebar pushes content
                            marginLeft: {
                                xs: 0,
                                sm: 'calc(var(--SideNavigation-slideIn, 0) * var(--Sidebar-width))',
                            },
                            transition: 'margin-left 0.4s',
                            flex: 1,
                            minHeight: 0,
                            pt: isFullBleedPage ? 'var(--Header-height)' : {
                                xs: 'calc(12px + var(--Header-height))',
                                sm: 'calc(12px + var(--Header-height))',
                                md: 'calc(12px + var(--Header-height))',
                            },
                            px: isFullBleedPage ? 0 : { xs: 1.5, sm: 2 },
                            pb: isFullBleedPage ? 0 : { xs: 2, sm: 2, md: 3 },
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: 0,
                            gap: isFullBleedPage ? 0 : 1,
                        }}
                    >
                        <Outlet />
                    </Box>
            </Box>
        </CssVarsProvider>
    );
}